var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLegalDocument = function SvgLegalDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeWidth: 3,
    d: "M6 28v-8C6 12.458 6 8.686 8.343 6.343S14.458 4 22 4h4c7.542 0 11.314 0 13.657 2.343S42 12.458 42 20v8c0 7.542 0 11.314-2.343 13.657S33.542 44 26 44h-4c-7.542 0-11.314 0-13.657-2.343S6 35.542 6 28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.667 21.333c2.11 2.11 4.889 4.254 4.889 4.254l3.809-3.81S29.221 19 27.111 16.89s-4.889-4.254-4.889-4.254l-3.81 3.81s2.145 2.778 4.255 4.888m0 0L16 28m16-6.857-5.08 5.08M22.858 12l-5.08 5.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M16 36h16"
  })));
};
export default SvgLegalDocument;